import { render } from "./UserInfoSection.vue?vue&type=template&id=70fe203c"
import script from "./UserInfoSection.vue?vue&type=script&lang=js"
export * from "./UserInfoSection.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__